export default {"src":"/_next/static/media/search.a3b11e00.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};